// extracted by mini-css-extract-plugin
export default {"addCategoryContainer":"addCategory_addCategoryContainer__ZlQXz","title":"addCategory_title__JamGR"};